module.exports = {
          srcSet: __webpack_public_path__ + "f1e535919968d2406c0922f1eaeba3a1-886.png"+" 886w",
          images:[ {path: __webpack_public_path__ + "f1e535919968d2406c0922f1eaeba3a1-886.png",width: 886,height: 390}],
          src: __webpack_public_path__ + "f1e535919968d2406c0922f1eaeba3a1-886.png",
          toString:function(){return __webpack_public_path__ + "f1e535919968d2406c0922f1eaeba3a1-886.png"},
          
          width: 886,
          height: 390
        }